import { LegacyLaunchPage } from "@/pages";
import { legacyLaunchPageQueryParamsSchema } from "@/pages/launch/schemata";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/_layout/_main/_centered/apps/$appId/launch/",
)({
  component: LegacyLaunchPage,
  validateSearch: legacyLaunchPageQueryParamsSchema,
});
